import React from 'react';

interface GongIconProps {
  className?: string;
  size?: number;
}

const GongIcon: React.FC<GongIconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill="#FF6B35"/>
      <path d="M8.5 7.5h7c1.38 0 2.5 1.12 2.5 2.5v4c0 1.38-1.12 2.5-2.5 2.5h-7c-1.38 0-2.5-1.12-2.5-2.5v-4c0-1.38 1.12-2.5 2.5-2.5z" fill="white"/>
      <path d="M10 10v4l3-2-3-2z" fill="#FF6B35"/>
      <circle cx="16" cy="8" r="1.5" fill="white"/>
    </svg>
  );
};

export default GongIcon;









